module.exports = __webpack_public_path__ + "static/media/uploaddark.2d8194d5.svg";